import { saveAs } from "file-saver";
import { IRow } from "../../components/table/collapse/CollapsibleTable";
import { IScanDisplay } from "../../models/stat";
import moment from "moment";
import "moment/locale/fr";
import "moment/locale/en-ca";
import { Dispatch, SetStateAction } from "react";

const parseMinutesToDecimal = (text: string) => {
    const h = parseInt(text.match(/(\d+)h/)?.[1] || "0");
    const m = parseInt(text.match(/(\d+)min/)?.[1] || "0");
    return (h + m / 60).toFixed(2);
};

const formatDate = (date: Date) => moment.utc(date).local().format("YYYYMMDD");
const formatTime = (date: Date) => moment.utc(date).local().format("HHmmss");

export const getAcombaTimesheet = (
    timesheet: IRow<IScanDisplay>[],
    companyName: string,
    setAcombaHasMissing: Dispatch<SetStateAction<boolean>>,
    setAcombaHasOverrides: Dispatch<SetStateAction<boolean>>
) => {
    const lines: string[] = [];
    lines.push(`{0_SIDE; Acomba Data eXchange; N; ${companyName}; 0_SIDE}`);
    lines.push("");

    let hasMissing = false;
    let hasOverrides = false;

    timesheet.forEach((row) => {
        const acombaEmployeeId = row.data.acombaEmployeeId;
        const acombaFunctionNumber = row.data.acombaFunctionNumber;
        if (!acombaEmployeeId || !acombaFunctionNumber) hasMissing = true;

        row.subRowData.forEach((scan) => {
            const startDate = scan.overridenStart || scan.date;
            const endDate = scan.overridenEnd || scan.endDate;
            if (!startDate || !endDate) return;

            if (
                // scan.overridenAdjustedMinutes ||
                scan.overridenMinutes ||
                scan.overridenStart ||
                scan.overridenEnd
            ) {
                hasOverrides = true;
            }

            const formattedStartDate = formatDate(startDate);
            const formattedEndDate = formatDate(endDate);
            const formattedStartTime = formatTime(startDate);
            const formattedEndTime = formatTime(endDate);
            const decimalHours = parseMinutesToDecimal(
                // scan.overridenAdjustedMinutes ||
                scan.overridenMinutes ||
                    // scan.adjustedMinutes ||
                    scan.minutes
            );

            const acombaProjectId = scan.acombaProjectId;
            if (!acombaProjectId) hasMissing = true;

            lines.push(
                `{0_PLNT; ${acombaEmployeeId || 0}; ${acombaFunctionNumber || 1}; ${acombaProjectId || 0}; ${formattedStartDate}; ${formattedEndDate}; ${formattedStartTime}; ${formattedEndTime}; ${decimalHours}; 0; 102; 0; ; -${decimalHours}; 0.000; 0.00; N; N; N; ; 0_PLNT}`
            );
        });
    });

    lines.push("");
    lines.push("{0_SEOF; Acomba Data eXchange; 0_SEOF}");

    setAcombaHasMissing(hasMissing);
    setAcombaHasOverrides(hasOverrides);

    const blob = new Blob([lines.join("\r\n")], {
        type: "text/plain;charset=utf-8",
    });

    saveAs(
        blob,
        `acomba-timesheet-${moment().format("YYYY-MM-DD_HHmmss")}.ADX`
    );
};
